import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import IBankBillet from "Types/BankBillet";
import { State } from "store/reducers";

export const GET_TRANSFER = "[TRANSFER EDIT] GET_TRANSFER";
export const GET_TRANSFER_SUCCESS = "[TRANSFER EDIT] GET_TRANSFER_SUCCESS";
export const GET_TRANSFER_FAILED = "[TRANSFER EDIT] GET_TRANSFER_FAILED";

export const EDIT_TRANSFER = "[TRANSFER EDIT] EDIT_TRANSFER";
export const EDIT_TRANSFER_SUCCESS = "[TRANSFER EDIT] EDIT_TRANSFER_SUCCESS";
export const EDIT_TRANSFER_FAILED = "[TRANSFER EDIT] EDIT_TRANSFER_FAILED";

export const SET_VALUE = "[TRANSFER EDIT] SET_VALUE";
export const CLEAR_VALUES = "[TRANSFER EDIT] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}
export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getBankBillet(id: string, callback?: Callback<IBankBillet>) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_TRANSFER });

		try {
			const { login } = getState() as State;

			const response = await api.sendGet("/BankBillet/" + id, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_TRANSFER_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_TRANSFER_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			callback && callback(error);

			return dispatch({
				type: GET_TRANSFER_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function updateBankBillet(callback?: Callback<IBankBillet>) {
	return async (dispatch, getState) => {
		dispatch({ type: EDIT_TRANSFER });

		try {
			const state = getState();

			const { login, bankBilletEdit } = state;

			const { item } = bankBilletEdit;

			const model = {
				...item
			};

			const response = await api.sendPut("/BankBillet/" + item.id, model, {
				Authorization: `Bearer ${login.token}`
			});

			if (response.ok) {
				dispatch({
					type: EDIT_TRANSFER_SUCCESS
				});

				callback && callback();
			} else {
				const result = await response.json();

				const errors = getErrors(result.errors);

				dispatch({
					type: EDIT_TRANSFER_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: EDIT_TRANSFER_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
